import React from 'react';
import type { BridgeOperationalState } from '../../hooks/bridgeQueries';

interface BridgeStatePillProps {
  state: BridgeOperationalState;
  isLoading?: boolean;
}

const STYLES: Record<BridgeOperationalState, { wrap: string; dot: string; label: string }> = {
  open: {
    wrap: 'border-green-500/40 bg-green-500/10 text-green-300',
    dot: 'bg-green-400',
    label: 'Bridge Open',
  },
  closed: {
    wrap: 'border-red-500/40 bg-red-500/10 text-red-300',
    dot: 'bg-red-400',
    label: 'Bridge temporarily closed',
  },
  unknown: {
    wrap: 'border-dark-600 bg-dark-800/80 text-dark-400',
    dot: 'bg-dark-400',
    label: 'Checking bridge status…',
  },
};

export default function BridgeStatePill({ state, isLoading = false }: BridgeStatePillProps) {
  const s = STYLES[state];
  const label = state === 'unknown' && !isLoading ? 'Bridge status unavailable' : s.label;

  return (
    <div
      role="status"
      aria-live="polite"
      className={`inline-flex items-center gap-2 rounded-full border px-3.5 py-1.5 text-xs font-semibold ${s.wrap}`}
    >
      <span className="relative flex h-2.5 w-2.5">
        {state === 'open' && (
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75" />
        )}
        <span className={`relative inline-flex h-2.5 w-2.5 rounded-full ${s.dot}`} />
      </span>
      {label}
    </div>
  );
}
